import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { EditableText } from '@/core/EditableText.atom';
import { AUTO_WIDTH_OFFSET } from '@/main/app.constants';
import { getWorksheetLink } from '@/main/routing.utilities';
import { setName } from '@/tableDefinitionEditor/tableDefinition.actions';
import { updateTableDefinitionName } from '@/tableDefinitionEditor/tableDefinition.utilities';
import { errorToast } from '@/utilities/toast.utilities';

export interface TreeBuilderHeaderProps {
  tableId: string;
  name: string;
  tableScopedTo?: string;
  workbookId?: string;
  workbookName?: string;
  canWrite?: boolean;
}

export const TreeBuilderHeader = ({
  tableId,
  name,
  tableScopedTo,
  workbookId,
  workbookName,
  canWrite = true,
}: TreeBuilderHeaderProps) => {
  const { t } = useTranslation();

  const updateTreeName = async (newName: string) => {
    const trimmedName = newName.trim();
    try {
      await updateTableDefinitionName({ tableDefinitionId: tableId, name: trimmedName });
      setName('ITEM', trimmedName);
    } catch (error) {
      errorToast({ httpResponseOrError: error });
    }
  };

  return (
    <>
      {workbookId && (workbookId === tableScopedTo || !tableId) && workbookName && (
        <div className="flexNoGrow flexNoOverflow flexColumnContainer flexCenter">
          <span className="mt0 mb2 fs11">
            <ul className="unstyled-list text-not-bold flexColumnContainer headerBreadcrumbs folderBreadcrumbs mt0 mb0 flexNoGrow">
              <li className="ml2" key="crumbId_workbook">
                <Link to={getWorksheetLink(workbookId)}>{workbookName}</Link>
              </li>
            </ul>
          </span>
        </div>
      )}
      <EditableText
        onUpdate={updateTreeName}
        value={name}
        textClasses="fs14 tw:min-w-5"
        testId="headerItemTableName"
        id="headerItemTableName"
        offsetWidth={AUTO_WIDTH_OFFSET}
        oneLineText={true}
        allowEditing={canWrite}
      />
    </>
  );
};
